import {
  useGetQuery,
  useLazyGetQuery,
  usePostMutation,
  usePutMutation,
} from "slices/api";
import {
  BILLING_CALCULATIONS,
  BILLING_CYCLE,
  SECURITY_DEPOSIT,
} from "tagTypes";

export const useGetSecurityDepositsQuery = (billingCycleId, query = {}) =>
  useGetQuery({
    endpoint: `/billing-cycle/${billingCycleId}/security-deposit-bill-calculation`,
    query,
    tags: [SECURITY_DEPOSIT],
  });

export const useGetUserSecurityDepositsCalculationsQuery = () =>
  useGetQuery({
    endpoint: "/security-deposit-bill-calculation/user/unpaid-bill",
    tags: [SECURITY_DEPOSIT, BILLING_CALCULATIONS],
  });

export const useLazyGetSecurityDepositsQuery = () => {
  const [getSecurityDeposits, data] = useLazyGetQuery();
  const getSecurityDeposit = async (billingCycleId, query = {}) =>
    await getSecurityDeposits(
      {
        endpoint: `/billing-cycle/${billingCycleId}/security-deposit-bill-calculation`,
        query,
        tags: [SECURITY_DEPOSIT],
      },
      true
    ).unwrap();
  return [getSecurityDeposit, data];
};

export const useLazyGetSecurityDepositChartQuery = () => {
  const [getSecurityDepositsChartData, data] = useLazyGetQuery();
  const getSecurityDepositChart = async (id) =>
    await getSecurityDepositsChartData(
      {
        endpoint: `/security-deposit-bill-calculation/${id}/approval-tracking`,
        tags: [SECURITY_DEPOSIT],
      },
      true
    ).unwrap();
  return [getSecurityDepositChart, data];
};

export const usePutUpdateSecurityDepositStatusMutation = () => {
  const [updateSecurityDepositStatus, data] = usePutMutation();
  const updateSecurityDepositsStatus = async (payload, toastMessage) =>
    await updateSecurityDepositStatus({
      endpoint: "/security-deposit-bill-calculation/approve",
      payload: payload || {},
      toastMessage,
      tags: [SECURITY_DEPOSIT],
    }).unwrap();
  return [updateSecurityDepositsStatus, data];
};

export const usePostSecurityDepositMutation = () => {
  const [dispatchSecurityDeposits, data] = usePostMutation();
  const setBillsPdf = async (billCycleId, payload = {}) =>
    await dispatchSecurityDeposits({
      endpoint: `/billing-cycle/${billCycleId}/dispatch-security-deposit-bill`,
      payload,
      toastMessage: "Security bills dispatched successfully",
      tags: [SECURITY_DEPOSIT],
    }).unwrap();
  return [setBillsPdf, data];
};

export const usePostGenerateSecurityDepositMutation = () => {
  const [generateSecurityDepositBills, data] = usePostMutation();
  const generateSecurityDepositBill = async (billCycleId, payload = {}) =>
    await generateSecurityDepositBills({
      endpoint: `/billing-cycle/${billCycleId}/security-deposit-bill-calculation`,
      payload,
      toastMessage:
        "You will be notified once all bill calculations are generated",
      tags: [SECURITY_DEPOSIT, BILLING_CYCLE],
    }).unwrap();
  return [generateSecurityDepositBill, data];
};

export const usePostSecurityDepositBillPaymentMutation = () => {
  const [dispatchBills, data] = usePostMutation();
  const setBillsPdf = async (calculationId, query = {}) =>
    await dispatchBills({
      endpoint: `/security-deposit-bill-calculation/${calculationId}/security-deposit-bill-payment`,
      query,
      tags: [SECURITY_DEPOSIT, BILLING_CALCULATIONS],
    }).unwrap();
  return [setBillsPdf, data];
};
